import { booleanAttribute, Component, input, numberAttribute } from '@angular/core';
import { Step2SimpleComponent } from 'src/app/components/consulting-reservation/step2-simple/step2.component';

@Component({
  selector: 'app-request-material',
  imports: [
    Step2SimpleComponent
  ],
  templateUrl: './request-material...html',
  styleUrl: './request-material...scss',
})
export class RequestMaterial {
  readonly lpType = input<string | null>(null);
  readonly discount = input(10, { transform: numberAttribute });
  readonly isCasual = input(false, { alias: 'casual', transform: booleanAttribute });
  readonly completeUrl = input<string>('');
}
